// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__zt-TK","number":"NotFound_number__2l7zC","text":"NotFound_text__3TLZ_"};